import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=652c88fe&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=652c88fe&lang=scss&scoped=true&"
import style1 from "./Settings.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652c88fe",
  null
  
)

export default component.exports